import { render } from "./backHeader.vue?vue&type=template&id=4e0a5fd4&scoped=true"
import script from "./backHeader.vue?vue&type=script&lang=js"
export * from "./backHeader.vue?vue&type=script&lang=js"

import "./backHeader.vue?vue&type=style&index=0&id=4e0a5fd4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e0a5fd4"

export default script